import { ROUTER_CONSTS } from './router.consts'

export const ROUTES_PATHS = {
  actions: {
    create: `create/:${ROUTER_CONSTS.params.id}?`,
    update: `update/:${ROUTER_CONSTS.params.id}`,
  },
}
